import React, { createContext, useEffect, useState } from "react";

import { apiList, getCancelData } from '../api/callAPI';

import useUser from '../hook/useUser';
import useGlobalStatus from "../hook/useGlobalStatus";
import useApiError from '../hook/useApiError';
import useCancel from '../hook/useCancel';

import * as alertConstants from '../constants/alertMsg';

const AllAdAccountContext = createContext();

export const AllAdAccountProvider = ({ children }) => {
  const { userData } = useUser();
  const { setIsLoadingLoginStatus } = useGlobalStatus();
  const { handleApiErrorStatus } = useApiError();
  const { cancelData, setCancelData } = useCancel();
  const [allAdAccount, setAllAdAccount] = useState([]);

  const fetchAllAdAccount = () => {
    setIsLoadingLoginStatus(true);

    let call;
    if (cancelData) {
      cancelData.cancel(alertConstants.CANCEL_REQUEST);
    }
    call = getCancelData();

    apiList.apiGetOwnedAdAccount({
      page: 0,
      size: 100000,
    }, call.token)
      .then(res => {
        if (res.message && res.message === alertConstants.CANCEL_REQUEST) return;
        if (res.status === 200) {
          setAllAdAccount(res.data.result.content);
        } else {
          handleApiErrorStatus(res);
        }
        setIsLoadingLoginStatus(false);
      })
  }

  useEffect(() => {
    if (!userData) return;

    fetchAllAdAccount();
  }, [userData])

  // console.log('AllAdAccountContext');

  return (
    <AllAdAccountContext.Provider
      value={{
        allAdAccount
      }}
    >
      {children}
    </AllAdAccountContext.Provider>
  )
}

export default AllAdAccountContext;